"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatientDeclined = void 0;
const react_1 = __importDefault(require("react"));
const react_native_1 = require("react-native");
const Dashboard_style_1 = require("./Dashboard.style");
const GlobalStyles_1 = require("../../../helper/GlobalStyles");
const PatientDeclined = (props) => {
    const { scrollToAktuel } = props;
    return (react_1.default.createElement(react_native_1.View, { onLayout: event => {
            const layout = event.nativeEvent.layout;
            scrollToAktuel(layout.x, layout.y, layout.width, layout.height / 2, true);
        } },
        react_1.default.createElement(react_native_1.Text, { style: [
                Dashboard_style_1.styles.heading3,
                GlobalStyles_1.globalStyles.marginTop30,
                { textTransform: 'none' },
            ] }, "Ihre Therapie ist unterbrochen"),
        react_1.default.createElement(react_native_1.Text, { style: [Dashboard_style_1.styles.text, GlobalStyles_1.globalStyles.marginTop25] }, "Eine Fortsetzung Ihrer Therapie mit nowomed ist derzeit nicht m\u00F6glich."),
        react_1.default.createElement(react_native_1.Text, { style: [Dashboard_style_1.styles.text, GlobalStyles_1.globalStyles.marginTop25] }, "Falls Sie weitere Fragen haben, wenden Sie sich bitte an unseren Support.")));
};
exports.PatientDeclined = PatientDeclined;
